import { IconChevronDown } from "./Icons";

export function WorkspaceSwitcher({
  handle,
  compact = false,
}: {
  handle: string;
  compact?: boolean;
}) {
  const initial = (handle?.[0] ?? "?").toUpperCase();
  return (
    <button
      type="button"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        background: compact ? "transparent" : "var(--bg-panel-2)",
        border: `1px solid ${compact ? "transparent" : "var(--border-default)"}`,
        borderRadius: 8,
        padding: compact ? "4px 8px" : "8px 10px",
        color: "var(--text-primary)",
        cursor: "pointer",
        fontSize: 13,
        fontWeight: 500,
      }}
    >
      <span
        aria-hidden
        style={{
          width: 22,
          height: 22,
          borderRadius: 6,
          background: "linear-gradient(135deg,#F59E0B,#EA580C)",
          color: "#1a1206",
          fontSize: 11,
          fontWeight: 700,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {initial}
      </span>
      <span style={{ flex: 1, textAlign: "left" }}>{handle}'s Workspace</span>
      <span style={{ color: "var(--text-tertiary)", display: "inline-flex" }}>
        <IconChevronDown />
      </span>
    </button>
  );
}
